import { createPersistentStore } from './storeUtils';

const store = createPersistentStore<Record<string, string>>({});

export function setCrumbOverride(pathname: string, label: string): void {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  store.set((prev) => {
    if (prev[normalized] === label) return prev;
    return { ...prev, [normalized]: label };
  });
}

export function clearCrumbOverride(pathname: string): void {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  store.set((prev) => {
    if (!(normalized in prev)) return prev;
    const next = { ...prev };
    delete next[normalized];
    return next;
  });
}

export function getCrumbOverride(pathname: string): string | undefined {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  return store.getSnapshot()[normalized];
}

export function subscribeCrumbs(listener: () => void): () => void {
  return store.subscribe(listener);
}

export function getCrumbsSnapshot(): Record<string, string> {
  return store.getSnapshot();
}
